import React from 'react';

import ContentMenu from './components/ContentMenu';
import CompanyPanel from '../Company/CompanyPanel';
import GroupPanel from '../Group/GroupPanel';

class DashboardView extends React.Component {
    render() {

        return (
            <div>
                <CompanyPanel />
                <GroupPanel />
                <ContentMenu />
            </div>
        );
    }
}
export default DashboardView;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/DashboardView.js